import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import { region, taskAssign } from "../../config/images";
import { useNavigate } from "react-router-dom";

const UserManagementDetail = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box className="task-detail-box">
        <Box className="d-flex justify-content-between align-items-center">
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.backArrow}
              alt=""
              style={{ height: "44px", width: "44px", cursor: "pointer" }}
              onClick={() => navigate("/user-management")}
            />
            <img
              src={region.region}
              alt=""
              style={{ height: "44px", width: "44px" }}
            />
            <Typography variant="h6" gutterBottom>
              User Management
            </Typography>
          </Box>
        </Box>
        <Box className="p-3 pb-0">
          <Box className="d-flex justify-content-between">
            <Typography variant="p">Roles(Module)</Typography>
            <Typography variant="p">Access</Typography>
          </Box>
        </Box>
        <hr className="mt-2" />
        <Box className="p-4 pt-0">
          <Box className="d-flex justify-content-between align-items-center">
            <Typography variant="p">Admin</Typography>
            <FormControl className="mb-3" style={{ width: "200px" }}>
              <InputLabel>Select Access</InputLabel>
              <Select
                label="Select Region"
                name="region"
                // value={taskData.region}
                // onChange={handleChange}
              >
                <MenuItem value="Region 1">Can View</MenuItem>
                <MenuItem value="Region 2">Can View & Edit</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box className="d-flex justify-content-between align-items-center">
            <Typography variant="p">Farmers</Typography>
            <FormControl className="mb-3" style={{ width: "200px" }}>
              <InputLabel>Select Access</InputLabel>
              <Select
                label="Select Region"
                name="region"
                // value={taskData.region}
                // onChange={handleChange}
              >
                <MenuItem value="Region 1">Can View</MenuItem>
                <MenuItem value="Region 2">Can View & Edit</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box className="d-flex justify-content-between align-items-center">
            <Typography variant="p">Task Assignment</Typography>
            <FormControl className="mb-3" style={{ width: "200px" }}>
              <InputLabel>Select Access</InputLabel>
              <Select
                label="Select Region"
                name="region"
                // value={taskData.region}
                // onChange={handleChange}
              >
                <MenuItem value="Region 1">Can View</MenuItem>
                <MenuItem value="Region 2">Can View & Edit</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box className="d-flex justify-content-between align-items-center">
            <Typography variant="p">Collectors</Typography>
            <FormControl className="mb-3" style={{ width: "200px" }}>
              <InputLabel>Select Access</InputLabel>
              <Select
                label="Select Region"
                name="region"
                // value={taskData.region}
                // onChange={handleChange}
              >
                <MenuItem value="Region 1">Can View</MenuItem>
                <MenuItem value="Region 2">Can View & Edit</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box className="d-flex justify-content-between align-items-center">
            <Typography variant="p">Report Submission</Typography>
            <FormControl className="mb-3" style={{ width: "200px" }}>
              <InputLabel>Select Access</InputLabel>
              <Select
                label="Select Region"
                name="region"
                // value={taskData.region}
                // onChange={handleChange}
              >
                <MenuItem value="Region 1">Can View</MenuItem>
                <MenuItem value="Region 2">Can View & Edit</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box className="d-flex justify-content-between align-items-center">
            <Typography variant="p">Category Master</Typography>
            <FormControl className="mb-3" style={{ width: "200px" }}>
              <InputLabel>Select Access</InputLabel>
              <Select
                label="Select Region"
                name="region"
                // value={taskData.region}
                // onChange={handleChange}
              >
                <MenuItem value="Region 1">Can View</MenuItem>
                <MenuItem value="Region 2">Can View & Edit</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box className="d-flex justify-content-between align-items-center">
            <Typography variant="p">User Management</Typography>
            <FormControl className="mb-3" style={{ width: "200px" }}>
              <InputLabel>Select Access</InputLabel>
              <Select
                label="Select Region"
                name="region"
                // value={taskData.region}
                // onChange={handleChange}
              >
                <MenuItem value="Region 1">Can View</MenuItem>
                <MenuItem value="Region 2">Can View & Edit</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box className="d-flex justify-content-between align-items-center">
            <Typography variant="p">Admin</Typography>
            <FormControl className="mb-3" style={{ width: "200px" }}>
              <InputLabel>Select Access</InputLabel>
              <Select
                label="Select Region"
                name="region"
                // value={taskData.region}
                // onChange={handleChange}
              >
                <MenuItem value="Region 1">Can View</MenuItem>
                <MenuItem value="Region 2">Can View & Edit</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default UserManagementDetail;
